import BaseService from '../BaseService'

class QueueService extends BaseService {
    constructor() {
        super('/campaigns/planned-notifications');
    }
}

export default new QueueService()
